import { api as com, apiFuns } from 'sw-hic';
let {get, post, put, del} = apiFuns
const api = {
  /** *************押金*************** **/
  //添加押金
  addDeposit: (para) => {
    return post("/api/ip/deposit", para);
  },
  // 修改押金
  editDeposit: (data, id) => {
    return put(`/api/ip/deposit/${id}`, data);
  },
  // 删除押金
  delDeposit: (id) => {
    return del(`/api/ip/deposit/${id}`);
  },
  //根据ID取得押金
  getDepositById: (id) => {
    return get(`/api/ip/deposit/${id}`);
  },
  //获取押金列表
  getDepositList: (data) => {
    return get(`/api/ip/deposit`, data);
  },
  //退预交金
  refundPayment: (id) => {
    return get(`/api/ip/deposit/refund/${id}`);
  },

  //通过患者住院号或者证件号等获取患者当前预交金总额和记账金额，以及患者信息。
  getPatientMoney: (ipNo) => {
    return get(`/api/ip/deposit/${ipNo}/amount`);
  },

  //添加打印次数
  paymentCounts: (id) => {
    return put(`/api/ip/deposit/print/${id}`);
  },

  //交费提醒列表
  getRemindList: (data) => {
    return post(`/api/ip/hospitalization/reminderList`, data);
  },
  //欠账列表
  getQZ: (data) => {
    return post(`/api/ip/ious/reminderApprovalList`, data);
  },
  //查询入院登记
  getAdmission: (data) => {
    return get(`/api/ip/hospitalization`, data);
  },

  /** **********欠账的接口****************** **/
  //添加欠费
  addArrearage: (para) => {
    return post("/api/ip/ious", para);
  },
  // 修改欠费
  editArrearage: (data, id) => {
    return put(`/api/ip/ious/${id}`, data);
  },
  // 删除欠费
  delArrearage: (id) => {
    return del(`/api/ip/ious/${id}`);
  },
  //根据ID取得欠费
  getArrearageById: (id) => {
    return get(`/api/ip/ious/${id}`);
  },
  //获取欠费列表
  getArrearageList: (data) => {
    return get(`/api/ip/ious`, data);
  },

  /** **********主api中的接口****************** **/

  // 根据证据号查询患者信息
  getPatientByIdNo: com.getPatientByIdNo,
  //根据ID取得患者信息
  getPatient: com.getPatient,
};

export default api;
